import { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { SIGN_UP, VERIFY_OTP } from '../graphql/Mutation/Signin.js';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import 'react-toastify/dist/ReactToastify.css';
import GoogleFacebookButton from '../firebase/facebook-google-button.js';
import SpinLoader from '../components/SpinLoader.js';
import useScrollToTop from '../components/useScrollToTop.js';

const Signup = ({ refetch }) => {
    useScrollToTop();
    const checkboxRef = useRef(null);
    const navigate = useNavigate();
    const [otpSent, setOtpSent] = useState(false);
    const [SignUp, { loading: signUpLoading }] = useMutation(SIGN_UP);
    const [verifyOtp, { loading }] = useMutation(VERIFY_OTP);
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [checkboxError, setCheckboxError] = useState(false);

    const handleCheckboxChange = (e) => {
        setIsCheckboxChecked(e.target.checked);
        setCheckboxError(false);
    };


    const formik = useFormik({
        initialValues: {
            email: '',
            otp: '',
            ApprovePrivacyPolicy: false,
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Invalid Email address').required('Enter Email Number'),
            otp: otpSent
                ? Yup.string().required('Enter OTP').matches(/^[0-9]{4}$/, 'OTP must be exactly 4 digits') : Yup.string(),
            ApprovePrivacyPolicy: otpSent ? Yup.boolean().oneOf([true], 'You must accept the privacy policy') : Yup.boolean(),
        }),
        onSubmit: async (values, { setSubmitting }) => {
            if (otpSent) {
                handleVerifyOtp(values, setSubmitting);
            } else {
                handleSignUp(values, setSubmitting);
            }
        },
    });

    const handleSignUp = async (values, setSubmitting) => {
        try {
            const { data } = await SignUp({ variables: { email: values.email.trim() } });
            if (data.signUp.success) {
                setOtpSent(true);
                toast.success('OTP sent to your email successfully. Please check your email.');
            } else {
                toast.error(data?.signUp?.message);
            }
        } catch (error) {
            toast.error(error?.message);
        } finally {
            setSubmitting(false);
        }
    };

    const handleVerifyOtp = async (values, setSubmitting) => {
        try {
            if (!isCheckboxChecked) {
                toast.error('You must accept the privacy policy');
            } else {
                const { data } = await verifyOtp({ variables: { email: values?.email, otp: values?.otp, ApprovePrivacyPolicy: isCheckboxChecked } });
                if (data?.verifyOtp?.success) {
                    localStorage.setItem('token', data?.verifyOtp?.token);
                    localStorage.setItem('id', data?.verifyOtp?.user?.id);
                    localStorage.setItem('role', data?.verifyOtp?.user?.userType);
                    await refetch();
                    if (data?.verifyOtp?.user?.userType === 'User') {
                        navigate("/");
                    } else {
                        navigate("/adminhome");

                    }
                    toast.success(data?.verifyOtp?.message);
                    setOtpSent(false);
                    formik.resetForm();
                } else {
                    toast.error(data?.verifyOtp?.message);
                }
            }
        } catch (error) {
            toast.error(error?.message);
        } finally {
            setSubmitting(false);
        }
    };

    const handleInputChange = (e, setFieldValue) => {
        if (!isCheckboxChecked) {
            setCheckboxError(true);
        }
        const { name, value } = e.target;
        const cleanedValue = value.replace(/\s+/g, '');
        setFieldValue(name, cleanedValue);
    };

    const [isContentVisible] = useState(true);



    const isLoading = loading || signUpLoading;
    return (
        <div>
            {/* <Header /> */}

            <div className="relative overflow-hidden bg-white">
                <div className="pt-4">
                    <div className="relative mx-auto max-w-7xl px-4 sm:static sm:px-6 lg:px-8">
                        <div className="sm:max-w-lg">
                            {/* Logo */}
                            {/* Logo */}
                            <Link to="/" className="flex items-center ml-4 mb-4 lg:ml-0">
                                <img
                                    src="/logo1.png"
                                    alt="AlgarXpress Logo"
                                    className="h-12 w-auto object-contain hidden sm:block"
                                />
                                <div className="flex flex-col ms-2">
                                    {/* Main Brand Name */}
                                    <p className="text-md font-bold text-slate-800 flex items-center">
                                        AlgarXpress
                                        <sup className="text-[10px] font-bold text-slate-700">™</sup>
                                    </p>

                                    {/* Subtitle / Certification */}
                                    <p className="text-xs font-semibold text-slate-500 mt-0.5">
                                        ISO 9001:2015 Certified Company
                                    </p>
                                </div>

                            </Link>
                            {/* <h1 className="text-2xl mb-4 font-bold tracking-tight text-gray-900">
                                Sign up / Sign in
                            </h1> */}
                            <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                                Seamless, Cost-Effective & Scalable Shipping
                            </h1>
                            <p className="mt-4 text-gray-500">
                                In today’s fast-paced world of e-commerce and logistics, having a robust, tech-driven shipping solution is essential for seamless operations. Our cutting-edge shipping platform is designed to empower businesses of all sizes with smart automation, real-time tracking, and a seamless shipping experience.
                            </p>

                            <form className="space-y-6 mt-10" onSubmit={formik.handleSubmit}>

                                <div>
                                    <GoogleFacebookButton isCheckboxChecked={isCheckboxChecked} setCheckboxError={setCheckboxError} refetch={refetch} checkboxRef={checkboxRef} />

                                    <div className="flex items-center mt-4 w-full">
                                        <div className="flex-grow border-t border-gray-300"></div>
                                        <span className="mx-2 text-slate-700 text-sm">or</span>
                                        <div className="flex-grow border-t border-gray-300"></div>
                                    </div>


                                    {isContentVisible && (

                                        <div className='mt-4'>
                                            <p className="lg:mt-4 mb-5 font-semibold text-sm text-gray-900">
                                                Register / Login with your Email ID to get started.
                                            </p>
                                            <div className=''>
                                                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                                    Email ID
                                                </label>
                                                <div className="mt-1">
                                                    <input
                                                        id="email"
                                                        name="email"
                                                        type="text"
                                                        placeholder="Enter Email ID"
                                                        autoComplete="email"
                                                        required
                                                        {...formik.getFieldProps('email')}
                                                        onChange={(e) => handleInputChange(e, formik.setFieldValue)}
                                                        className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-r-full border-0 py-2.5 px-4 text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400 sm:leading-6"
                                                    />
                                                    {formik.touched.email && formik.errors.email ? (
                                                        <div className="text-red-600 text-sm mt-1">{formik.errors.email}</div>
                                                    ) : null}
                                                </div>
                                            </div>

                                            {otpSent && (
                                                <div className='mb-8 mt-4'>
                                                    <label htmlFor="otp" className="block text-sm font-medium leading-6 text-gray-900">
                                                        OTP
                                                    </label>
                                                    <div className="mt-1">
                                                        <input
                                                            id="otp"
                                                            name="otp"
                                                            type="number"
                                                            onWheel={(e) => e.target.blur()}
                                                            autoComplete="otp"
                                                            placeholder="Enter OTP"
                                                            required
                                                            {...formik.getFieldProps('otp')}
                                                            onChange={(e) => handleInputChange(e, formik.setFieldValue)}
                                                            className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-r-full border-0 py-2.5 px-4 text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400 sm:leading-6"
                                                        />
                                                        {formik.touched.otp && formik.errors.otp ? (
                                                            <div className="text-red-600 text-sm mt-1">{formik.errors.otp}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            )}

                                            <div className='mt-3' ref={checkboxRef}>
                                                <div className={`flex space-x-2 items-center ${checkboxError || (formik.touched.ApprovePrivacyPolicy && formik.errors.ApprovePrivacyPolicy) ? '' : ''}`}>
                                                    <input
                                                        type="checkbox"
                                                        id="ApprovePrivacyPolicy"
                                                        name="ApprovePrivacyPolicy"
                                                        className="h-4 w-4 text-blue-600 rounded"
                                                        onChange={(e) => {
                                                            handleCheckboxChange(e);
                                                            formik.handleChange(e);
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        checked={isCheckboxChecked || formik.values.ApprovePrivacyPolicy}
                                                    />
                                                    <p htmlFor="ApprovePrivacyPolicy" className='font-semibold text-sm'>Accepted <Link to='/privacyPolicy' className='text-blue-600'> Privacy Policy</Link><Link to='/termsAndConditions' className='text-blue-600'> & Teams</Link></p>
                                                </div>
                                                {(checkboxError || (formik.touched.ApprovePrivacyPolicy && formik.errors.ApprovePrivacyPolicy)) && (
                                                    <p className="text-red-500 text-sm mt-1">{checkboxError ? 'Please Accept Terms and Conditions.' : formik.errors.ApprovePrivacyPolicy}</p>
                                                )}
                                            </div>

                                            <div>
                                                <button
                                                    type="submit"
                                                    disabled={!isCheckboxChecked || isLoading}
                                                    className={`inline-block rounded-md border border-transparent bg-slate-600 px-8 py-3 text-center font-medium text-white hover:bg-slate-700 mt-6
                    ${!isCheckboxChecked || isLoading ? 'bg-slate-700 cursor-not-allowed' : 'bg-slate-700 hover:shadow-md hover:bg-slate-800'}`}
                                                >
                                                    {isLoading ? <SpinLoader /> : (otpSent ? 'Verify OTP' : 'Request OTP')}
                                                </button>
                                            </div>
                                            {/* <div>
                                                <button
                                                    type="submit"
                                                    disabled={isLoading}
                                                    className={`inline-block rounded-md border border-transparent bg-slate-600 px-8 py-3 text-center font-medium text-white hover:bg-slate-700 mt-6
                                                ${isLoading ? 'bg-slate-700 cursor-not-allowed' : 'bg-slate-700 hover:shadow-md hover:bg-slate-800'}`}
                                                >
                                                    {isLoading ? (
                                                        <SpinLoader />
                                                    ) : (
                                                        otpSent ? 'Verify OTP' : 'Request OTP'
                                                    )}
                                                </button>
                                            </div> */}
                                        </div>
                                    )}

                                </div>
                            </form>
                        </div>
                        <div>
                            <div className="mt-10">
                                <div
                                    aria-hidden="true"
                                    className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl"
                                >
                                    <div className="absolute transform sm:top-0 sm:left-1/2 sm:translate-x-8 lg:top-1/2 lg:left-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                                        <div className="flex items-center space-x-6 lg:space-x-8">
                                            <div className="grid shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                                <div className="h-64 w-44 overflow-hidden rounded-lg sm:opacity-0 lg:opacity-100">
                                                    <img
                                                        alt=""
                                                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/algarXpreeswarehouse.png"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                                <div className="h-64 w-44 md:hidden lg:block overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/algarwarehouse.png"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                            <div className="grid shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/freepik__the-image-shows-a-person-in-a-traditional-outfit-s__39675.png"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/freepik__the-second-image-depicts-a-row-of-trucks-parked-ou__39676.png"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/freepik__the-fourth-image-shows-a-warehouse-interior-where-__39674.png"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                            <div className="grid shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/0ecd212b-6a8b-4c92-94b9-b11c34eba7d1.jpg"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/algarboxpic.png"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Signup
